import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const MyButton = ({
  to,
  text,
  id,
  type,
  variant,
  m,
  p,
  border = "solid 0.04rem #3A3A3A",
  hover = { background: "#3A3A3A", color: "#f1f1f1" },
  _hover,
  ariaLabel,
  color,
  bg,
}) => {
  return (
    <Link to={to}>
      <Button
        type={type}
        id={id}
        variant={variant}
        m={m}
        p={p}
        border={border}
        _hover={_hover || hover}
        aria-label={ariaLabel}
        color={color}
        backgroundColor={bg}
      >
        {text}
      </Button>
    </Link>
  );
};

export default MyButton;
